import { KennoFile } from '@pandiafi/design-system'

import {
  CreateDefectNotice,
  DefectNoticeDetails,
} from '../../../common/validations/defectNotice'

export interface FormValues extends Omit<
  CreateDefectNotice,
  'fileUuids' | 'contractUuid' | 'defectLocation' | 'defectClassId'
> {
  files: KennoFile[]
  defectLocation: string
  defectClassId: string
}

const initialValues = (existing?: DefectNoticeDetails | null): FormValues => {
  if (existing) {
    return {
      title: existing.title,
      description: existing.description,
      defectLocation: existing.defectLocation === 'CONTRACT_TARGET' ? '0' : '1',
      defectClassId: existing.defectClassId
        ? `${existing.defectClassId}`
        : '-1',
      files: existing.files ? existing.files : [],
      masterKeyAccessAllowed: existing.masterKeyAccessAllowed,
      hasPetsInApartment: existing.hasPetsInApartment,
      noticeReporter: existing.noticeReporter
        ? {
            phoneNumber: existing.noticeReporter.phoneNumber ?? '',
            email: existing.noticeReporter.email ?? '',
          }
        : null,
    }
  }
  return {
    title: '',
    description: '',
    defectLocation: '',
    defectClassId: '',
    files: [],
    masterKeyAccessAllowed: false,
    hasPetsInApartment: false,
    noticeReporter: null,
  }
}

export default initialValues
